import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { HomeIcon, MapPinIcon, EuroIcon, PhoneIcon, MailIcon, CheckCircleIcon, XIcon, ImageIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { useRental } from '../../contexts/RentalContext';
export function ListingPreview() {
  const {
    id
  } = useParams<{
    id: string;
  }>();
  const {
    getListingById
  } = useRental();
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [showContactForm, setShowContactForm] = useState(false);
  const [contactData, setContactData] = useState({
    name: '',
    phone: '',
    email: '',
    message: ''
  });
  const listing = getListingById(id || '');
  if (!listing) {
    return <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4" data-id="element-10218">
        <div className="text-center" data-id="element-10219">
          <HomeIcon className="w-20 h-20 text-gray-300 mx-auto mb-4" data-id="element-10220" />
          <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-10221">
            Anunț indisponibil
          </h2>
          <p className="text-gray-600" data-id="element-10222">
            Acest anunț nu mai este disponibil sau a fost șters.
          </p>
        </div>
      </div>;
  }
  const handlePrevImage = () => {
    setCurrentImageIndex(prev => prev === 0 ? (listing.images?.length || 1) - 1 : prev - 1);
  };
  const handleNextImage = () => {
    setCurrentImageIndex(prev => prev === (listing.images?.length || 1) - 1 ? 0 : prev + 1);
  };
  const handleContactSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    alert(`Mulțumim pentru interes! Vă vom contacta în curând la numărul ${contactData.phone}.`);
    setShowContactForm(false);
    setContactData({
      name: '',
      phone: '',
      email: '',
      message: ''
    });
  };
  return <div className="min-h-screen bg-gray-50" data-id="element-10223">
      {/* Header */}
      <div className="bg-white border-b border-gray-200 sticky top-0 z-40" data-id="element-10224">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-4" data-id="element-10225">
          <div className="flex items-center justify-between" data-id="element-10226">
            <div className="flex items-center space-x-3" data-id="element-10227">
              <div className="w-10 h-10 bg-gradient-to-br from-[#357BEB] to-[#21A366] rounded-lg flex items-center justify-center" data-id="element-10228">
                <HomeIcon className="w-6 h-6 text-white" data-id="element-10229" />
              </div>
              <div data-id="element-10230">
                <h1 className="text-lg font-bold text-gray-900" data-id="element-10231">
                  Cautlocuinta.ro
                </h1>
                <p className="text-xs text-gray-500" data-id="element-10232">Agenție Imobiliară</p>
              </div>
            </div>
            <button onClick={() => setShowContactForm(true)} className="flex items-center space-x-2 bg-[#21A366] text-white px-6 py-3 rounded-lg font-semibold hover:bg-[#1a8555] transition-colors shadow-md" data-id="element-10233">
              <PhoneIcon className="w-5 h-5" data-id="element-10234" />
              <span data-id="element-10235">Contactează-ne</span>
            </button>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-10236">
        {/* Image Gallery */}
        {listing.images && listing.images.length > 0 && <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="bg-white rounded-2xl shadow-xl overflow-hidden mb-8" data-id="element-10237">
            <div className="relative aspect-[16/9] bg-gray-900" data-id="element-10238">
              <img src={listing.images[currentImageIndex]} alt={`Imagine ${currentImageIndex + 1}`} className="w-full h-full object-contain" data-id="element-10239" />

              {listing.images.length > 1 && <>
                  <button onClick={handlePrevImage} className="absolute left-4 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-white bg-opacity-90 hover:bg-opacity-100 rounded-full flex items-center justify-center transition-all shadow-lg" data-id="element-10240">
                    <ChevronLeftIcon className="w-6 h-6 text-gray-900" data-id="element-10241" />
                  </button>
                  <button onClick={handleNextImage} className="absolute right-4 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-white bg-opacity-90 hover:bg-opacity-100 rounded-full flex items-center justify-center transition-all shadow-lg" data-id="element-10242">
                    <ChevronRightIcon className="w-6 h-6 text-gray-900" data-id="element-10243" />
                  </button>

                  <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 bg-black bg-opacity-70 text-white px-4 py-2 rounded-full text-sm font-semibold flex items-center space-x-2" data-id="element-10244">
                    <ImageIcon className="w-4 h-4" data-id="element-10245" />
                    <span data-id="element-10246">
                      {currentImageIndex + 1} / {listing.images.length}
                    </span>
                  </div>
                </>}
            </div>

            {listing.images.length > 1 && <div className="p-4 grid grid-cols-6 gap-2 bg-gray-50" data-id="element-10247">
                {listing.images.map((img, idx) => <button key={idx} onClick={() => setCurrentImageIndex(idx)} className={`aspect-square rounded-lg overflow-hidden border-2 transition-all ${idx === currentImageIndex ? 'border-[#357BEB] scale-105' : 'border-gray-200 hover:border-gray-300'}`} data-id="element-10248">
                    <img src={img} alt={`Thumbnail ${idx + 1}`} className="w-full h-full object-cover" data-id="element-10249" />
                  </button>)}
              </div>}
          </motion.div>}

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-10250">
          {/* Property Details */}
          <div className="lg:col-span-2 space-y-6" data-id="element-10251">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.1
          }} className="bg-white rounded-2xl shadow-lg p-8" data-id="element-10252">
              <div className="flex items-start justify-between mb-6" data-id="element-10253">
                <div data-id="element-10254">
                  <h1 className="text-4xl font-bold text-gray-900 mb-3" data-id="element-10255">
                    {listing.propertyType.charAt(0).toUpperCase() + listing.propertyType.slice(1)}{' '}
                    {listing.rooms} camere
                  </h1>
                  <div className="flex items-center text-gray-600 text-lg" data-id="element-10256">
                    <MapPinIcon className="w-5 h-5 mr-2" data-id="element-10257" />
                    <span data-id="element-10258">{listing.zone}</span>
                  </div>
                </div>
              </div>

              <div className="flex items-baseline mb-8 pb-8 border-b-2 border-gray-100" data-id="element-10259">
                <span className="text-5xl font-bold text-[#357BEB]" data-id="element-10260">
                  {listing.price}
                </span>
                <span className="text-2xl text-gray-600 ml-2" data-id="element-10261">
                  {listing.currency}
                </span>
                <span className="text-lg text-gray-500 ml-1" data-id="element-10262">/lună</span>
              </div>

              <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-8" data-id="element-10263">
                <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-4 text-center" data-id="element-10264">
                  <p className="text-sm text-gray-600 mb-1" data-id="element-10265">Suprafață</p>
                  <p className="text-2xl font-bold text-gray-900" data-id="element-10266">
                    {listing.surface}
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-10267">mp</p>
                </div>
                <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-xl p-4 text-center" data-id="element-10268">
                  <p className="text-sm text-gray-600 mb-1" data-id="element-10269">Camere</p>
                  <p className="text-2xl font-bold text-gray-900" data-id="element-10270">
                    {listing.rooms}
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-10271">camere</p>
                </div>
                <div className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-xl p-4 text-center" data-id="element-10272">
                  <p className="text-sm text-gray-600 mb-1" data-id="element-10273">Etaj</p>
                  <p className="text-2xl font-bold text-gray-900" data-id="element-10274">
                    {listing.floor}
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-10275">etaj</p>
                </div>
                <div className="bg-gradient-to-br from-orange-50 to-orange-100 rounded-xl p-4 text-center" data-id="element-10276">
                  <p className="text-sm text-gray-600 mb-1" data-id="element-10277">Mobilare</p>
                  <p className="text-sm font-bold text-gray-900 capitalize" data-id="element-10278">
                    {listing.amenities.furnished}
                  </p>
                </div>
              </div>

              <div data-id="element-10279">
                <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-10280">
                  Descriere
                </h2>
                <p className="text-gray-700 leading-relaxed whitespace-pre-line text-lg" data-id="element-10281">
                  {listing.description || 'Nicio descriere disponibilă.'}
                </p>
              </div>

              <div className="mt-8" data-id="element-10282">
                <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-10283">
                  Dotări & Facilități
                </h3>
                <div className="flex flex-wrap gap-3" data-id="element-10284">
                  <span className="px-4 py-2 bg-gray-100 text-gray-700 rounded-xl text-sm font-semibold capitalize flex items-center space-x-2" data-id="element-10285">
                    <CheckCircleIcon className="w-4 h-4 text-green-600" data-id="element-10286" />
                    <span data-id="element-10287">{listing.amenities.furnished}</span>
                  </span>
                  <span className="px-4 py-2 bg-gray-100 text-gray-700 rounded-xl text-sm font-semibold capitalize flex items-center space-x-2" data-id="element-10288">
                    <CheckCircleIcon className="w-4 h-4 text-green-600" data-id="element-10289" />
                    <span data-id="element-10290">
                      {listing.amenities.heating === 'centrala' ? 'Centrală proprie' : 'Termoficare'}
                    </span>
                  </span>
                  {listing.amenities.parking && <span className="px-4 py-2 bg-[#357BEB] bg-opacity-10 text-[#357BEB] rounded-xl text-sm font-semibold flex items-center space-x-2" data-id="element-10291">
                      <CheckCircleIcon className="w-4 h-4" data-id="element-10292" />
                      <span data-id="element-10293">Loc parcare</span>
                    </span>}
                  {listing.amenities.balcony && <span className="px-4 py-2 bg-[#357BEB] bg-opacity-10 text-[#357BEB] rounded-xl text-sm font-semibold flex items-center space-x-2" data-id="element-10294">
                      <CheckCircleIcon className="w-4 h-4" data-id="element-10295" />
                      <span data-id="element-10296">Balcon</span>
                    </span>}
                  {listing.amenities.pets && <span className="px-4 py-2 bg-[#21A366] bg-opacity-10 text-[#21A366] rounded-xl text-sm font-semibold flex items-center space-x-2" data-id="element-10297">
                      <CheckCircleIcon className="w-4 h-4" data-id="element-10298" />
                      <span data-id="element-10299">Animale acceptate</span>
                    </span>}
                </div>
              </div>
            </motion.div>
          </div>

          {/* Contact Card - Sticky */}
          <div className="lg:col-span-1" data-id="element-10300">
            <motion.div initial={{
            opacity: 0,
            x: 20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: 0.2
          }} className="bg-white rounded-2xl shadow-xl p-6 sticky top-24" data-id="element-10301">
              <div className="bg-gradient-to-br from-[#357BEB] to-[#21A366] rounded-xl p-6 text-white mb-6" data-id="element-10302">
                <h3 className="text-xl font-bold mb-2" data-id="element-10303">Interesat?</h3>
                <p className="text-white text-opacity-90 text-sm" data-id="element-10304">
                  Contactează-ne pentru mai multe detalii sau pentru a programa
                  o vizionare.
                </p>
              </div>

              <button onClick={() => setShowContactForm(true)} className="w-full flex items-center justify-center space-x-2 bg-[#21A366] text-white px-6 py-4 rounded-xl font-bold text-lg hover:bg-[#1a8555] transition-colors shadow-lg mb-4" data-id="element-10305">
                <PhoneIcon className="w-6 h-6" data-id="element-10306" />
                <span data-id="element-10307">Contactează Agenția</span>
              </button>

              <div className="text-center text-sm text-gray-600 space-y-2" data-id="element-10308">
                <p data-id="element-10309">Program: Luni - Vineri, 09:00 - 18:00</p>
                <p className="font-semibold text-gray-900" data-id="element-10310">
                  Răspuns în maxim 2 ore
                </p>
              </div>

              <div className="mt-6 pt-6 border-t border-gray-200" data-id="element-10311">
                <p className="text-xs text-gray-500 text-center" data-id="element-10312">
                  ID Anunț:{' '}
                  <span className="font-bold text-gray-900" data-id="element-10313">{listing.id}</span>
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </div>

      {/* Contact Form Modal */}
      {showContactForm && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4" data-id="element-10314">
          <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} className="bg-white rounded-2xl shadow-2xl max-w-lg w-full p-8" data-id="element-10315">
            <div className="flex items-center justify-between mb-6" data-id="element-10316">
              <h3 className="text-2xl font-bold text-gray-900" data-id="element-10317">
                Solicită Informații
              </h3>
              <button onClick={() => setShowContactForm(false)} className="p-2 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-10318">
                <XIcon className="w-6 h-6 text-gray-600" data-id="element-10319" />
              </button>
            </div>

            <form onSubmit={handleContactSubmit} className="space-y-4" data-id="element-10320">
              <div data-id="element-10321">
                <label className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-10322">
                  Nume Complet *
                </label>
                <input type="text" required value={contactData.name} onChange={e => setContactData({
              ...contactData,
              name: e.target.value
            })} placeholder="Ex: Ion Popescu" className="w-full px-4 py-3 border-2 border-gray-300 rounded-xl focus:outline-none focus:border-[#357BEB] transition-colors" data-id="element-10323" />
              </div>

              <div data-id="element-10324">
                <label className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-10325">
                  Telefon *
                </label>
                <input type="tel" required value={contactData.phone} onChange={e => setContactData({
              ...contactData,
              phone: e.target.value
            })} placeholder="Ex: 0721234567" className="w-full px-4 py-3 border-2 border-gray-300 rounded-xl focus:outline-none focus:border-[#357BEB] transition-colors" data-id="element-10326" />
              </div>

              <div data-id="element-10327">
                <label className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-10328">
                  Email (opțional)
                </label>
                <input type="email" value={contactData.email} onChange={e => setContactData({
              ...contactData,
              email: e.target.value
            })} placeholder="Ex: ion@email.com" className="w-full px-4 py-3 border-2 border-gray-300 rounded-xl focus:outline-none focus:border-[#357BEB] transition-colors" data-id="element-10329" />
              </div>

              <div data-id="element-10330">
                <label className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-10331">
                  Mesaj (opțional)
                </label>
                <textarea rows={4} value={contactData.message} onChange={e => setContactData({
              ...contactData,
              message: e.target.value
            })} placeholder="Întrebări sau detalii suplimentare..." className="w-full px-4 py-3 border-2 border-gray-300 rounded-xl focus:outline-none focus:border-[#357BEB] transition-colors resize-none" data-id="element-10332" />
              </div>

              <button type="submit" className="w-full bg-[#21A366] text-white px-6 py-4 rounded-xl font-bold text-lg hover:bg-[#1a8555] transition-colors shadow-lg" data-id="element-10333">
                Trimite Solicitare
              </button>

              <p className="text-xs text-gray-500 text-center" data-id="element-10334">
                Prin trimiterea formularului, ești de acord să fii contactat de
                agenția noastră.
              </p>
            </form>
          </motion.div>
        </div>}
    </div>;
}